import holidayService from '../../../common/service/holidayService';

const LANDING_METADATA_API = '/landing/metadata';

const getLandingMetaData = (params = {}) => holidayService.post(LANDING_METADATA_API, params);

export default getLandingMetaData;
